import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class ActionsApi {
  // ------ Action Type API ------
  static getAllNotificationTypes(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.notificationTypeList, { params });
  }

  static getAllNotifications(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.notificationList, { params });
  }

  static acknowledgeNotification(props) {
    const { id, acknowledge_date } = props;
    return axios.put(ApiEndpoints.notification.replace(':id:', id), { acknowledge_date });
  }

  static getAllNotificationRules(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.notificationRuleList, { params });
  }

  static addNotificationRule(params) {
    return axios.post(ApiEndpoints.notificationRuleList, params);
  }

  static updateNotificationRule(params) {
    const { id } = params;
    // remove context on update
    const data = {
      ...params,
      context_theme_id: undefined,
      context_object: undefined
    };
    return axios.patch(ApiEndpoints.notificationRule.replace(':id:', id), data);
  }

  static deleteNotificationRule(params) {
    const { id } = params;
    const data = {
      ids: Array.isArray(id) ? id : [id]
    };
    return axios.delete(ApiEndpoints.notificationRuleBulk, { data });
  }

  static getNotificationRule({ id }) {
    return axios.get(ApiEndpoints.notificationRule.replace(':id:', id));
  }

  static getNotificationTheme(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.notificationTheme, { params });
  }

  static getAllNotificationRuns(props) {
    const {
      page, pageSize, filters, sorted, version_id
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.notificationRunList.replace(':v_id:', version_id), { params });
  }

  static addNotificationRun(params) {
    const { version_id, ...rest } = params;
    return axios.post(ApiEndpoints.notificationRunList.replace(':v_id:', version_id), { ...rest });
  }

  static updateNotificationRun(params) {
    const { id, version_id, ...rest } = params;
    // remove context on update
    const data = {
      ...rest,
      context_theme_id: undefined,
      context_object: undefined
    };
    return axios.patch(ApiEndpoints.notificationRun.replace(':id:', id)
      .replace(':v_id:', version_id), data);
  }

  static deleteNotificationRun(params) {
    const { id, version_id } = params;
    const data = {
      ids: Array.isArray(id) ? id : [id]
    };
    return axios.delete(ApiEndpoints.notificationRunBulk.replace(':v_id:', version_id), { data });
  }

  static getNotificationRun({ id, version_id }) {
    return axios.get(ApiEndpoints.notificationRun.replace(':id:', id)
      .replace(':v_id:', version_id));
  }
}

export default ActionsApi;
